import { globalMixin } from '../../../mixins/global-mixin'
import Decimal from 'decimal.js'

export const convertToNumber = (amount, thousandSeparator) => {
  return parseFloat(
    globalMixin.methods.numberUnFormatter(
      `${amount}`,
      thousandSeparator
    ).replace(',', '.')
  )
}

export const calculateAmount = (poList, thousandSeparator) => {
  const shouldCalculateTotalAmount = (po) => {
    return !!po.amount && !po.error
  }
  return poList
    .filter(shouldCalculateTotalAmount)
    .map(po => po.amount)
    .reduce((total, amount) => {
      return new Decimal(total).add(convertToNumber(amount, thousandSeparator)).toNumber()
    }, 0)
}
